export default __webpack_public_path__ + "static/homepage-7d2c7db099198f0b4e125900b19030db.mp4";